export default (string) => string === 'true' || string === '1' || string > 0;